// Shared non-pricing translations.

export const languages = [
  { code: 'en', name: 'English', dir: 'ltr' },
  { code: 'tr', name: 'Türkçe', dir: 'ltr' },
  { code: 'es', name: 'Español', dir: 'ltr' },
  { code: 'fr', name: 'Français', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', dir: 'ltr' },
  { code: 'pt', name: 'Português', dir: 'ltr' },
  { code: 'ar', name: 'العربية', dir: 'rtl' },
];

export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      clinicWebsiteDesign: 'Clinic Website Design',
      conversionFocusedWebsites: 'Conversion-Focused Websites',
      howItWorks: 'How It Works',
      industries: 'Industries',
      pricing: 'Pricing',
      modules: 'Modules',
      plans: 'Plans',
      work: 'Work',
      resources: 'Resources',
      contact: 'Contact',
      bookCall: 'Book Call',
      bookConsultation: 'Book a Consultation',
      contactWebouse: 'Contact Webouse',
      projectCta: 'Discuss Your Project',
    },
    common: {
      serviceEyebrow: 'WEBOUSE SERVICE',
      servicesEyebrow: 'Webouse services',
      resourcesEyebrow: 'Webouse resources',
      guideEyebrow: 'Webouse guide',
      caseStudyEyebrow: 'Case study',
      entityEyebrow: 'Entity information',
      projectConsultation: 'Project consultation',
      viewServiceDetails: 'View service details',
      readResources: 'Read resources',
      viewServices: 'View services',
      sendProjectDetails: 'Send project details',
      relatedServices: 'Related Services',
      relatedResources: 'Related Resources',
      nextResource: 'Next Resource',
      lastUpdated: 'Last updated',
      contentOwner: 'Content owner',
      author: 'Author',
      updated: 'Updated',
      externalSources: 'External sources are listed in the article data file for factual review.',
      noExternalClaims: 'No external statistical claims are used in this guide.',
      backToHome: 'Back to home',
      officialDomain: 'Official domain',
      instagram: 'Instagram',
      privacy: 'Privacy',
      terms: 'Terms',
      cookies: 'Cookies',
      breadcrumb: 'Breadcrumb',
      pricingCurrency: 'Pricing currency',
      languageSelector: 'Language selector',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      whatsapp: 'WhatsApp',
    },
    hero: {
      eyebrow: 'A business system, built around results',
      headlineLine1: 'Your Website Should Work.',
      headlineLine2: 'Not Just Exist.',
      subheadline:
        'Webouse designs and develops custom websites, booking flows and lead-generation systems that help visitors understand your offer and contact your team.',
      cta1: 'Discuss My Project',
      cta2: 'See How It Works',
      trustItems: [
        'Clear scope before development begins',
        'Delivered in as little as 5 days',
        'Custom built for your business',
        'No templates. No unnecessary features.',
      ],
      systemLabel: 'Business system live',
      systemStatus: 'Working 24/7',
      activity: 'Live activity',
      systemCards: [
        'New Lead',
        'Appointment Confirmed',
        'AI Reply Sent',
        'New Customer',
        'Analytics Growth',
      ],
      signal1: 'Availability',
      signal2: 'Conversion',
      signal3: 'Manual work',
    },
    results: {
      line1: "Businesses don't need another website.",
      line2: 'They need results.',
      outcomes: [
        'More Leads',
        'More Bookings',
        'Less Manual Work',
        'Higher Conversions',
      ],
    },
    howItWorks: {
      title: 'How It Works',
      steps: [
        { number: '01', title: 'Discovery & Strategy', desc: 'We learn about your business, goals, customers and operational challenges.' },
        { number: '02', title: 'Proposal & Planning', desc: 'We recommend the right website, automation and growth system for your needs.' },
        { number: '03', title: 'Design, Build & Launch', desc: 'We design, develop, test and launch your custom business system.' },
      ],
    },
    quote: {
      line1: "You don't buy a website.",
      line2: 'You get a digital sales system that works 24/7 for your business.',
      line3: 'Start small. Add what you need. Scale when you grow.',
    },
    cta: {
      title: 'Let’s Build the Right System for Your Business.',
      description: 'Tell us about your goals, challenges and current website. We’ll recommend the right solution for your business.',
      button: 'Tell Us About Your Project',
      subtext: 'Clear scope. Transparent pricing. A solution built around your business.',
    },
    footer: {
      tagline: 'Business Growth Systems',
      copyright: '© 2026 Webouse. All rights reserved.',
      secure: 'No online payment. We confirm every project directly.',
      description: 'Generate more leads, save staff time, automate repetitive work and convert more visitors into customers.',
      quickLinks: 'Quick Links',
      contactUs: 'Contact Us',
      worldwide: 'Serving businesses worldwide',
      whatsappQuestion: 'Hi! I have a question.',
    },
    form: {
      name: 'Your Name',
      email: 'Your Email',
      phone: 'Phone Number',
      business: 'Business Name',
      message: 'Tell us about your project',
      submit: 'Start the Conversation',
      whatsappChoice: 'Prefer WhatsApp? Contact us directly.',
      emailLabel: 'Email',
      contactIntro: 'Hi Webouse, I would like to discuss a project for my business.',
      project: 'Project',
      saveWarning: 'Your message could not be saved, but WhatsApp has been opened.',
      opening: 'Opening WhatsApp...',
    },
    cart: {
      title: 'Your Selection',
      package: 'Package',
      addons: 'Modules',
      plan: 'Monthly Plan',
      oneTime: 'One-time',
      monthly: 'Monthly',
      checkout: 'Send Request via WhatsApp',
      empty: 'No items selected',
    },
  },
  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      services: 'Hizmetler',
      clinicWebsiteDesign: 'Klinik Web Sitesi Tasarımı',
      conversionFocusedWebsites: 'Dönüşüm Odaklı Web Siteleri',
      howItWorks: 'Nasıl Çalışır',
      industries: 'Sektörler',
      pricing: 'Fiyatlandırma',
      modules: 'Modüller',
      plans: 'Planlar',
      work: 'Çalışmalar',
      resources: 'Kaynaklar',
      contact: 'İletişim',
      bookCall: 'Görüşme Planla',
      bookConsultation: 'Danışmanlık Görüşmesi Planla',
      contactWebouse: 'Webouse ile İletişime Geç',
      projectCta: 'Projenizi Görüşelim',
    },
    common: {
      serviceEyebrow: 'WEBOUSE HİZMETİ',
      servicesEyebrow: 'Webouse hizmetleri',
      resourcesEyebrow: 'Webouse kaynakları',
      guideEyebrow: 'Webouse rehberi',
      caseStudyEyebrow: 'Vaka çalışması',
      entityEyebrow: 'Kurumsal bilgiler',
      projectConsultation: 'Proje danışmanlığı',
      viewServiceDetails: 'Hizmet detaylarını incele',
      readResources: 'Kaynakları oku',
      viewServices: 'Hizmetleri incele',
      sendProjectDetails: 'Proje detaylarını gönder',
      relatedServices: 'İlgili Hizmetler',
      relatedResources: 'İlgili Kaynaklar',
      nextResource: 'Sonraki Kaynak',
      lastUpdated: 'Son güncelleme',
      contentOwner: 'İçerik sahibi',
      author: 'Yazar',
      updated: 'Güncellendi',
      externalSources: 'Dış kaynaklar, doğruluk incelemesi için makale veri dosyasında listelenir.',
      noExternalClaims: 'Bu rehberde dış istatistik iddiası kullanılmaz.',
      backToHome: 'Ana sayfaya dön',
      officialDomain: 'Resmi domain',
      instagram: 'Instagram',
      privacy: 'Gizlilik',
      terms: 'Şartlar',
      cookies: 'Çerezler',
      breadcrumb: 'Sayfa yolu',
      pricingCurrency: 'Fiyat para birimi',
      languageSelector: 'Dil seçici',
      openMenu: 'Menüyü aç',
      closeMenu: 'Menüyü kapat',
      whatsapp: 'WhatsApp',
    },
    hero: {
      eyebrow: 'Sonuçlar için tasarlanmış bir iş sistemi',
      headlineLine1: 'Web Siteniz Çalışmalı.',
      headlineLine2: 'Sadece Var Olmamalı.',
      subheadline:
        'Web sitenizi müşteri adayı üreten, randevu alan, müşterileri yanıtlayan ve siz uyurken bile işletmenizi büyüten bir sisteme dönüştürün.',
      cta1: 'Projemi Görüşelim',
      cta2: 'Nasıl Çalıştığını Gör',
      trustItems: [
        'Geliştirme başlamadan önce net kapsam',
        '5 gün gibi kısa bir sürede teslim',
        'İşletmenize özel olarak geliştirilir',
        'Şablon yok. Gereksiz özellik yok.',
      ],
      systemLabel: 'İş sistemi aktif',
      systemStatus: '7/24 çalışıyor',
      activity: 'Canlı hareket',
      systemCards: [
        'Yeni Müşteri Adayı',
        'Randevu Onaylandı',
        'Yapay Zekâ Yanıtı Gönderildi',
        'Yeni Müşteri',
        'Analitik Büyüme',
      ],
      signal1: 'Erişilebilirlik',
      signal2: 'Dönüşüm',
      signal3: 'Manuel iş',
    },
    results: {
      line1: 'İşletmelerin yeni bir web sitesine ihtiyacı yok.',
      line2: 'Sonuçlara ihtiyacı var.',
      outcomes: [
        'Daha Fazla Talep',
        'Daha Fazla Randevu',
        'Daha Az Manuel İş',
        'Daha Yüksek Dönüşüm',
      ],
    },
    howItWorks: {
      title: 'Nasıl Çalışır',
      steps: [
        { number: '01', title: 'Keşif ve Strateji', desc: 'İşletmenizi, hedeflerinizi, müşterilerinizi ve operasyonel sorunlarınızı analiz ederiz.' },
        { number: '02', title: 'Teklif ve Planlama', desc: 'İhtiyaçlarınıza uygun web sitesi, otomasyon ve büyüme sistemini planlarız.' },
        { number: '03', title: 'Tasarım, Geliştirme ve Yayın', desc: 'Özel sisteminizi tasarlar, geliştirir, test eder ve yayına alırız.' },
      ],
    },
    quote: {
      line1: 'Sadece bir web sitesi satın almazsınız.',
      line2: 'İşletmeniz için 7/24 çalışan dijital bir satış sistemi edinirsiniz.',
      line3: 'Küçük başlayın. İhtiyacınızı ekleyin. Büyüdükçe ölçekleyin.',
    },
    cta: {
      title: 'İşletmeniz İçin Doğru Sistemi Birlikte Kuralım.',
      description: 'Hedeflerinizi, karşılaştığınız zorlukları ve mevcut web sitenizi anlatın. İşletmeniz için doğru çözümü önerelim.',
      button: 'Projenizi Bize Anlatın',
      subtext: 'Net kapsam. Şeffaf fiyatlandırma. İşletmenize göre tasarlanmış bir çözüm.',
    },
    footer: {
      tagline: 'İşletme Büyüme Sistemleri',
      copyright: '© 2026 Webouse. Tüm hakları saklıdır.',
      secure: 'Online ödeme yok. Her projeyi doğrudan teyit ediyoruz.',
      description: 'Daha fazla talep oluşturun, ekibinize zaman kazandırın, tekrarlayan işleri otomatikleştirin ve daha çok ziyaretçiyi müşteriye dönüştürün.',
      quickLinks: 'Hızlı Bağlantılar',
      contactUs: 'Bize Ulaşın',
      worldwide: 'Dünya genelindeki işletmelere hizmet veriyoruz',
      whatsappQuestion: 'Merhaba! Bir sorum var.',
    },
    form: {
      name: 'Adınız',
      email: 'E-postanız',
      phone: 'Telefon Numaranız',
      business: 'İşletme Adı',
      message: 'Projenizi anlatın',
      submit: 'Görüşmeyi Başlat',
      whatsappChoice: 'WhatsApp’ı mı tercih ediyorsunuz? Bize doğrudan ulaşın.',
      emailLabel: 'E-posta',
      contactIntro: 'Merhaba Webouse, işletmem için bir proje hakkında görüşmek istiyorum.',
      project: 'Proje',
      saveWarning: 'Mesajınız kaydedilemedi ancak WhatsApp açıldı.',
      opening: 'WhatsApp açılıyor...',
    },
    cart: {
      title: 'Seçiminiz',
      package: 'Paket',
      addons: 'Modüller',
      plan: 'Aylık Plan',
      oneTime: 'Tek seferlik',
      monthly: 'Aylık',
      checkout: 'WhatsApp ile Talep Gönder',
      empty: 'Seçili öğe yok',
    },
  },
  es: {
    nav: {
      howItWorks: 'Cómo Funciona',
      pricing: 'Precios',
      modules: 'Módulos',
      plans: 'Planes',
      contact: 'Contacto',
      projectCta: 'Hablemos de Tu Proyecto',
    },
    hero: {
      eyebrow: 'Un sistema empresarial diseñado para resultados',
      headlineLine1: 'Tu Sitio Debe Trabajar.',
      headlineLine2: 'No Solo Existir.',
      subheadline:
        'Convierte tu sitio en un sistema que genera leads, reserva citas, responde a clientes y hace crecer tu negocio, incluso mientras duermes.',
      cta1: 'Hablemos de Mi Proyecto',
      cta2: 'Ver Cómo Funciona',
      trustItems: [
        'Alcance claro antes de iniciar el desarrollo',
        'Entrega desde solo 5 días',
        'Creado a medida para tu negocio',
        'Sin plantillas. Sin funciones innecesarias.',
      ],
      systemLabel: 'Sistema empresarial activo',
      systemStatus: 'Trabajando 24/7',
      activity: 'Actividad en vivo',
      systemCards: [
        'Nuevo Lead',
        'Cita Confirmada',
        'Respuesta de IA Enviada',
        'Nuevo Cliente',
        'Crecimiento Analítico',
      ],
      signal1: 'Disponibilidad',
      signal2: 'Conversión',
      signal3: 'Trabajo manual',
    },
    results: {
      line1: 'Las empresas no necesitan otro sitio web.',
      line2: 'Necesitan resultados.',
      outcomes: [
        'Más Leads',
        'Más Reservas',
        'Menos Trabajo Manual',
        'Más Conversiones',
      ],
    },
    howItWorks: {
      title: 'Cómo Funciona',
      steps: [
        { number: '01', title: 'Descubrimiento y Estrategia', desc: 'Conocemos tu negocio, objetivos, clientes y retos operativos.' },
        { number: '02', title: 'Propuesta y Planificación', desc: 'Recomendamos el sitio web, la automatización y el sistema de crecimiento adecuados para tus necesidades.' },
        { number: '03', title: 'Diseño, Desarrollo y Lanzamiento', desc: 'Diseñamos, desarrollamos, probamos y lanzamos tu sistema empresarial a medida.' },
      ],
    },
    quote: {
      line1: 'No compras solo un sitio web.',
      line2: 'Obtienes un sistema de ventas digital que trabaja 24/7 para tu negocio.',
      line3: 'Empieza pequeño. Añade lo que necesitas. Escala cuando crezcas.',
    },
    cta: {
      title: 'Construyamos el Sistema Adecuado para Tu Negocio.',
      description: 'Cuéntanos tus objetivos, desafíos y cómo funciona tu sitio actual. Te recomendaremos la solución adecuada para tu negocio.',
      button: 'Cuéntanos Sobre Tu Proyecto',
      subtext: 'Alcance claro. Precios transparentes. Una solución creada en torno a tu negocio.',
    },
    footer: {
      tagline: 'Sistemas de Crecimiento Empresarial',
      copyright: '© 2026 Webouse. Todos los derechos reservados.',
      secure: 'Sin pago online. Confirmamos cada proyecto directamente.',
      description: 'Genera más leads, ahorra tiempo al equipo, automatiza tareas repetitivas y convierte más visitantes en clientes.',
      quickLinks: 'Enlaces Rápidos',
      contactUs: 'Contáctanos',
      worldwide: 'Trabajamos con empresas de todo el mundo',
      whatsappQuestion: '¡Hola! Tengo una pregunta.',
    },
    form: {
      name: 'Tu Nombre',
      email: 'Tu Email',
      phone: 'Número de Teléfono',
      business: 'Nombre de la Empresa',
      message: 'Cuéntanos sobre tu proyecto',
      submit: 'Iniciar la Conversación',
      whatsappChoice: '¿Prefieres WhatsApp? Contáctanos directamente.',
      emailLabel: 'Email',
      contactIntro: 'Hola Webouse, me gustaría hablar sobre un proyecto para mi negocio.',
      project: 'Proyecto',
      saveWarning: 'No se pudo guardar tu mensaje, pero WhatsApp se ha abierto.',
      opening: 'Abriendo WhatsApp...',
    },
    cart: {
      title: 'Tu Selección',
      package: 'Paquete',
      addons: 'Módulos',
      plan: 'Plan Mensual',
      oneTime: 'Pago único',
      monthly: 'Mensual',
      checkout: 'Enviar Solicitud por WhatsApp',
      empty: 'No hay elementos seleccionados',
    },
  },
  fr: {
    nav: {
      howItWorks: 'Comment Ça Marche',
      pricing: 'Tarifs',
      modules: 'Modules',
      plans: 'Plans',
      contact: 'Contact',
      projectCta: 'Parlons de Votre Projet',
    },
    hero: {
      eyebrow: 'Un système d’entreprise conçu pour les résultats',
      headlineLine1: 'Votre Site Doit Travailler.',
      headlineLine2: 'Pas Seulement Exister.',
      subheadline:
        'Transformez votre site en un système qui génère des prospects, réserve des rendez-vous, répond aux clients et développe votre activité, même pendant votre sommeil.',
      cta1: 'Parlons de Mon Projet',
      cta2: 'Voir Comment Ça Marche',
      trustItems: [
        'Un périmètre clair avant le début du développement',
        'Livraison possible dès 5 jours',
        'Conçu sur mesure pour votre entreprise',
        'Aucun modèle. Aucune fonction inutile.',
      ],
      systemLabel: 'Système d’entreprise actif',
      systemStatus: 'Actif 24 h/24',
      activity: 'Activité en direct',
      systemCards: [
        'Nouveau Prospect',
        'Rendez-vous Confirmé',
        'Réponse IA Envoyée',
        'Nouveau Client',
        'Croissance Analytique',
      ],
      signal1: 'Disponibilité',
      signal2: 'Conversion',
      signal3: 'Travail manuel',
    },
    results: {
      line1: 'Les entreprises n’ont pas besoin d’un site de plus.',
      line2: 'Elles ont besoin de résultats.',
      outcomes: [
        'Plus de Prospects',
        'Plus de Réservations',
        'Moins de Travail Manuel',
        'Plus de Conversions',
      ],
    },
    howItWorks: {
      title: 'Comment Ça Marche',
      steps: [
        { number: '01', title: 'Découverte et Stratégie', desc: 'Nous découvrons votre entreprise, vos objectifs, vos clients et vos enjeux opérationnels.' },
        { number: '02', title: 'Proposition et Planification', desc: 'Nous recommandons le site web, les automatisations et le système de croissance adaptés à vos besoins.' },
        { number: '03', title: 'Conception, Développement et Lancement', desc: 'Nous concevons, développons, testons et lançons votre système d’entreprise sur mesure.' },
      ],
    },
    quote: {
      line1: 'Vous n’achetez pas simplement un site web.',
      line2: 'Vous obtenez un système de vente numérique qui travaille 24 h/24 pour votre entreprise.',
      line3: 'Commencez simplement. Ajoutez vos besoins. Évoluez avec votre croissance.',
    },
    cta: {
      title: 'Construisons le Système Adapté à Votre Entreprise.',
      description: 'Parlez-nous de vos objectifs, de vos défis et de votre site actuel. Nous vous recommanderons la solution adaptée à votre entreprise.',
      button: 'Parlez-Nous de Votre Projet',
      subtext: 'Un périmètre clair. Des tarifs transparents. Une solution conçue autour de votre entreprise.',
    },
    footer: {
      tagline: 'Systèmes de Croissance pour Entreprises',
      copyright: '© 2026 Webouse. Tous droits réservés.',
      secure: 'Aucun paiement en ligne. Chaque projet est confirmé directement.',
      description: 'Générez plus de prospects, libérez du temps pour votre équipe, automatisez les tâches répétitives et convertissez davantage de visiteurs.',
      quickLinks: 'Liens Rapides',
      contactUs: 'Nous Contacter',
      worldwide: 'Au service des entreprises du monde entier',
      whatsappQuestion: 'Bonjour ! J’ai une question.',
    },
    form: {
      name: 'Votre Nom',
      email: 'Votre E-mail',
      phone: 'Numéro de Téléphone',
      business: 'Nom de l’Entreprise',
      message: 'Parlez-nous de votre projet',
      submit: 'Démarrer la Conversation',
      whatsappChoice: 'Vous préférez WhatsApp ? Contactez-nous directement.',
      emailLabel: 'E-mail',
      contactIntro: 'Bonjour Webouse, je souhaite discuter d’un projet pour mon entreprise.',
      project: 'Projet',
      saveWarning: 'Votre message n’a pas pu être enregistré, mais WhatsApp a été ouvert.',
      opening: 'Ouverture de WhatsApp...',
    },
    cart: {
      title: 'Votre Sélection',
      package: 'Forfait',
      addons: 'Modules',
      plan: 'Plan Mensuel',
      oneTime: 'Paiement unique',
      monthly: 'Mensuel',
      checkout: 'Envoyer la Demande sur WhatsApp',
      empty: 'Aucun élément sélectionné',
    },
  },
  de: {
    nav: {
      howItWorks: 'So Funktioniert Es',
      pricing: 'Preise',
      modules: 'Module',
      plans: 'Pläne',
      contact: 'Kontakt',
      projectCta: 'Projekt Besprechen',
    },
    hero: {
      eyebrow: 'Ein Geschäftssystem, das auf Ergebnisse ausgerichtet ist',
      headlineLine1: 'Ihre Website Muss Arbeiten.',
      headlineLine2: 'Nicht Nur Existieren.',
      subheadline:
        'Machen Sie Ihre Website zu einem System, das Leads gewinnt, Termine bucht, Kunden antwortet und Ihr Unternehmen wachsen lässt – selbst während Sie schlafen.',
      cta1: 'Mein Projekt Besprechen',
      cta2: 'So Funktioniert Es',
      trustItems: [
        'Klarer Leistungsumfang vor Entwicklungsbeginn',
        'Lieferung bereits ab 5 Tagen',
        'Individuell für Ihr Unternehmen entwickelt',
        'Keine Vorlagen. Keine unnötigen Funktionen.',
      ],
      systemLabel: 'Geschäftssystem aktiv',
      systemStatus: 'Arbeitet rund um die Uhr',
      activity: 'Live-Aktivität',
      systemCards: [
        'Neuer Lead',
        'Termin Bestätigt',
        'KI-Antwort Gesendet',
        'Neuer Kunde',
        'Analytics-Wachstum',
      ],
      signal1: 'Verfügbarkeit',
      signal2: 'Conversion',
      signal3: 'Manuelle Arbeit',
    },
    results: {
      line1: 'Unternehmen brauchen nicht noch eine Website.',
      line2: 'Sie brauchen Ergebnisse.',
      outcomes: [
        'Mehr Leads',
        'Mehr Buchungen',
        'Weniger Manuelle Arbeit',
        'Höhere Conversions',
      ],
    },
    howItWorks: {
      title: 'So Funktioniert Es',
      steps: [
        { number: '01', title: 'Analyse & Strategie', desc: 'Wir lernen Ihr Unternehmen, Ihre Ziele, Ihre Kunden und Ihre betrieblichen Herausforderungen kennen.' },
        { number: '02', title: 'Angebot & Planung', desc: 'Wir empfehlen die passende Website, Automatisierung und Wachstumslösung für Ihre Anforderungen.' },
        { number: '03', title: 'Design, Entwicklung & Launch', desc: 'Wir konzipieren, entwickeln, testen und veröffentlichen Ihr individuelles Geschäftssystem.' },
      ],
    },
    quote: {
      line1: 'Sie kaufen nicht nur eine Website.',
      line2: 'Sie erhalten ein digitales Verkaufssystem, das rund um die Uhr für Ihr Unternehmen arbeitet.',
      line3: 'Klein starten. Bedarf ergänzen. Mit dem Wachstum skalieren.',
    },
    cta: {
      title: 'Lassen Sie Uns das Richtige System für Ihr Unternehmen Entwickeln.',
      description: 'Erzählen Sie uns von Ihren Zielen, Herausforderungen und Ihrer aktuellen Website. Wir empfehlen die passende Lösung für Ihr Unternehmen.',
      button: 'Erzählen Sie Uns von Ihrem Projekt',
      subtext: 'Klarer Leistungsumfang. Transparente Preise. Eine Lösung, die auf Ihr Unternehmen zugeschnitten ist.',
    },
    footer: {
      tagline: 'Systeme für Unternehmenswachstum',
      copyright: '© 2026 Webouse. Alle Rechte vorbehalten.',
      secure: 'Keine Online-Zahlung. Jedes Projekt wird direkt bestätigt.',
      description: 'Gewinnen Sie mehr Leads, sparen Sie Teamzeit, automatisieren Sie wiederkehrende Aufgaben und verwandeln Sie mehr Besucher in Kunden.',
      quickLinks: 'Schnellzugriff',
      contactUs: 'Kontakt',
      worldwide: 'Für Unternehmen weltweit',
      whatsappQuestion: 'Hallo! Ich habe eine Frage.',
    },
    form: {
      name: 'Ihr Name',
      email: 'Ihre E-Mail',
      phone: 'Telefonnummer',
      business: 'Unternehmensname',
      message: 'Beschreiben Sie Ihr Projekt',
      submit: 'Gespräch Beginnen',
      whatsappChoice: 'Sie bevorzugen WhatsApp? Kontaktieren Sie uns direkt.',
      emailLabel: 'E-Mail',
      contactIntro: 'Hallo Webouse, ich möchte ein Projekt für mein Unternehmen besprechen.',
      project: 'Projekt',
      saveWarning: 'Ihre Nachricht konnte nicht gespeichert werden, WhatsApp wurde jedoch geöffnet.',
      opening: 'WhatsApp wird geöffnet...',
    },
    cart: {
      title: 'Ihre Auswahl',
      package: 'Paket',
      addons: 'Module',
      plan: 'Monatsplan',
      oneTime: 'Einmalig',
      monthly: 'Monatlich',
      checkout: 'Anfrage per WhatsApp Senden',
      empty: 'Keine Elemente ausgewählt',
    },
  },
  pt: {
    nav: {
      howItWorks: 'Como Funciona',
      pricing: 'Preços',
      modules: 'Módulos',
      plans: 'Planos',
      contact: 'Contato',
      projectCta: 'Fale Sobre Seu Projeto',
    },
    hero: {
      eyebrow: 'Um sistema empresarial criado para gerar resultados',
      headlineLine1: 'Seu Site Deve Trabalhar.',
      headlineLine2: 'Não Apenas Existir.',
      subheadline:
        'Transforme seu site em um sistema que gera leads, agenda compromissos, responde clientes e ajuda sua empresa a crescer, até enquanto você dorme.',
      cta1: 'Falar Sobre Meu Projeto',
      cta2: 'Ver Como Funciona',
      trustItems: [
        'Escopo claro antes do início do desenvolvimento',
        'Entrega a partir de apenas 5 dias',
        'Desenvolvido sob medida para sua empresa',
        'Sem templates. Sem recursos desnecessários.',
      ],
      systemLabel: 'Sistema empresarial ativo',
      systemStatus: 'Trabalhando 24 horas',
      activity: 'Atividade ao vivo',
      systemCards: [
        'Novo Lead',
        'Agendamento Confirmado',
        'Resposta de IA Enviada',
        'Novo Cliente',
        'Crescimento Analítico',
      ],
      signal1: 'Disponibilidade',
      signal2: 'Conversão',
      signal3: 'Trabalho manual',
    },
    results: {
      line1: 'Empresas não precisam de mais um site.',
      line2: 'Precisam de resultados.',
      outcomes: [
        'Mais Leads',
        'Mais Agendamentos',
        'Menos Trabalho Manual',
        'Mais Conversões',
      ],
    },
    howItWorks: {
      title: 'Como Funciona',
      steps: [
        { number: '01', title: 'Descoberta e Estratégia', desc: 'Conhecemos sua empresa, seus objetivos, seus clientes e seus desafios operacionais.' },
        { number: '02', title: 'Proposta e Planejamento', desc: 'Recomendamos o site, a automação e o sistema de crescimento adequados às suas necessidades.' },
        { number: '03', title: 'Design, Desenvolvimento e Lançamento', desc: 'Criamos, desenvolvemos, testamos e lançamos seu sistema empresarial personalizado.' },
      ],
    },
    quote: {
      line1: 'Você não compra apenas um site.',
      line2: 'Você recebe um sistema digital de vendas que trabalha 24 horas por dia para sua empresa.',
      line3: 'Comece pequeno. Adicione o necessário. Escale conforme cresce.',
    },
    cta: {
      title: 'Vamos Criar o Sistema Certo para Sua Empresa.',
      description: 'Conte-nos sobre seus objetivos, desafios e site atual. Recomendaremos a solução certa para sua empresa.',
      button: 'Conte-Nos Sobre Seu Projeto',
      subtext: 'Escopo claro. Preços transparentes. Uma solução criada em torno da sua empresa.',
    },
    footer: {
      tagline: 'Sistemas de Crescimento Empresarial',
      copyright: '© 2026 Webouse. Todos os direitos reservados.',
      secure: 'Sem pagamento online. Confirmamos cada projeto diretamente.',
      description: 'Gere mais leads, economize tempo da equipe, automatize tarefas repetitivas e converta mais visitantes em clientes.',
      quickLinks: 'Links Rápidos',
      contactUs: 'Fale Conosco',
      worldwide: 'Atendendo empresas em todo o mundo',
      whatsappQuestion: 'Olá! Tenho uma pergunta.',
    },
    form: {
      name: 'Seu Nome',
      email: 'Seu E-mail',
      phone: 'Número de Telefone',
      business: 'Nome da Empresa',
      message: 'Conte-nos sobre seu projeto',
      submit: 'Iniciar a Conversa',
      whatsappChoice: 'Prefere WhatsApp? Fale diretamente conosco.',
      emailLabel: 'E-mail',
      contactIntro: 'Olá Webouse, gostaria de conversar sobre um projeto para minha empresa.',
      project: 'Projeto',
      saveWarning: 'Não foi possível salvar sua mensagem, mas o WhatsApp foi aberto.',
      opening: 'Abrindo o WhatsApp...',
    },
    cart: {
      title: 'Sua Seleção',
      package: 'Pacote',
      addons: 'Módulos',
      plan: 'Plano Mensal',
      oneTime: 'Pagamento único',
      monthly: 'Mensal',
      checkout: 'Enviar Solicitação pelo WhatsApp',
      empty: 'Nenhum item selecionado',
    },
  },
  ar: {
    nav: {
      howItWorks: 'كيف يعمل',
      pricing: 'الأسعار',
      modules: 'الوحدات',
      plans: 'الخطط',
      contact: 'التواصل',
      projectCta: 'ناقش مشروعك',
    },
    hero: {
      eyebrow: 'نظام أعمال مصمم لتحقيق النتائج',
      headlineLine1: 'يجب أن يعمل موقعك.',
      headlineLine2: 'لا أن يوجد فقط.',
      subheadline:
        'حوّل موقعك إلى نظام يجذب العملاء المحتملين ويحجز المواعيد ويرد على العملاء ويساعد نشاطك على النمو، حتى أثناء نومك.',
      cta1: 'ناقش مشروعي',
      cta2: 'اكتشف آلية العمل',
      trustItems: [
        'نطاق عمل واضح قبل بدء التطوير',
        'التسليم خلال 5 أيام فقط',
        'مصمم خصيصًا لنشاطك',
        'لا قوالب. لا ميزات غير ضرورية.',
      ],
      systemLabel: 'نظام الأعمال نشط',
      systemStatus: 'يعمل على مدار الساعة',
      activity: 'نشاط مباشر',
      systemCards: [
        'عميل محتمل جديد',
        'تم تأكيد الموعد',
        'تم إرسال رد الذكاء الاصطناعي',
        'عميل جديد',
        'نمو التحليلات',
      ],
      signal1: 'التوافر',
      signal2: 'التحويل',
      signal3: 'العمل اليدوي',
    },
    results: {
      line1: 'لا تحتاج الشركات إلى موقع آخر.',
      line2: 'بل تحتاج إلى نتائج.',
      outcomes: [
        'عملاء محتملون أكثر',
        'حجوزات أكثر',
        'عمل يدوي أقل',
        'تحويلات أعلى',
      ],
    },
    howItWorks: {
      title: 'كيف يعمل',
      steps: [
        { number: '01', title: 'الاكتشاف والاستراتيجية', desc: 'نتعرّف على نشاطك وأهدافك وعملائك والتحديات التشغيلية التي تواجهها.' },
        { number: '02', title: 'المقترح والتخطيط', desc: 'نوصي بنظام الموقع والأتمتة والنمو الأنسب لاحتياجاتك.' },
        { number: '03', title: 'التصميم والتطوير والإطلاق', desc: 'نصمم نظام أعمالك المخصص ونطوره ونختبره ونطلقه.' },
      ],
    },
    quote: {
      line1: 'أنت لا تشتري مجرد موقع.',
      line2: 'بل تحصل على نظام مبيعات رقمي يعمل لنشاطك على مدار الساعة.',
      line3: 'ابدأ ببساطة. أضف ما تحتاجه. توسع مع نموك.',
    },
    cta: {
      title: 'لنطوّر النظام المناسب لنشاطك.',
      description: 'أخبرنا عن أهدافك وتحدياتك وموقعك الحالي، وسنوصي بالحل المناسب لنشاطك.',
      button: 'أخبرنا عن مشروعك',
      subtext: 'نطاق واضح. أسعار شفافة. حل مصمم حول احتياجات نشاطك.',
    },
    footer: {
      tagline: 'أنظمة نمو الأعمال',
      copyright: '© 2026 Webouse. جميع الحقوق محفوظة.',
      secure: 'لا يوجد دفع عبر الإنترنت. نؤكد كل مشروع مباشرة.',
      description: 'اجذب المزيد من العملاء المحتملين ووفر وقت فريقك وأتمت المهام المتكررة وحوّل المزيد من الزوار إلى عملاء.',
      quickLinks: 'روابط سريعة',
      contactUs: 'تواصل معنا',
      worldwide: 'نخدم الشركات حول العالم',
      whatsappQuestion: 'مرحبًا! لدي سؤال.',
    },
    form: {
      name: 'اسمك',
      email: 'بريدك الإلكتروني',
      phone: 'رقم الهاتف',
      business: 'اسم النشاط',
      message: 'أخبرنا عن مشروعك',
      submit: 'ابدأ المحادثة',
      whatsappChoice: 'تفضّل واتساب؟ تواصل معنا مباشرةً.',
      emailLabel: 'البريد الإلكتروني',
      contactIntro: 'مرحبًا Webouse، أود مناقشة مشروع لنشاطي.',
      project: 'المشروع',
      saveWarning: 'تعذر حفظ رسالتك، لكن تم فتح واتساب.',
      opening: 'جارٍ فتح واتساب...',
    },
    cart: {
      title: 'اختياراتك',
      package: 'الباقة',
      addons: 'الوحدات',
      plan: 'الخطة الشهرية',
      oneTime: 'دفعة واحدة',
      monthly: 'شهريًا',
      checkout: 'إرسال الطلب عبر واتساب',
      empty: 'لا توجد عناصر مختارة',
    },
  },
};

const mergeTranslationInEnglishOrder = (base, target = {}) =>
  Object.keys(base).reduce((ordered, key) => {
    const baseValue = base[key];
    const targetValue = target[key];

    if (Array.isArray(baseValue) || typeof baseValue !== 'object' || baseValue === null) {
      ordered[key] = targetValue ?? baseValue;
      return ordered;
    }

    ordered[key] = {
      ...baseValue,
      ...(targetValue && typeof targetValue === 'object' && !Array.isArray(targetValue) ? targetValue : {}),
    };
    return ordered;
  }, {});

Object.keys(translations)
  .filter((code) => code !== 'en' && code !== 'tr')
  .forEach((code) => {
    translations[code] = mergeTranslationInEnglishOrder(translations.en, translations[code]);
  });
